import { Menu, MenuItem } from "@blueprintjs/core";
import React from "react";

import styles from "./play-item-context-menu.module.scss";

interface PlayItemContextMenuProps {
  onRemovePlay: () => void;
}

const PlayItemContextMenu = ({ onRemovePlay }: PlayItemContextMenuProps) => {
  return (
    <Menu className={styles.contextMenu}>
      <MenuItem text="Remove Play From Playbook" onClick={onRemovePlay} icon="trash" />
    </Menu>
  );
};

export default PlayItemContextMenu;
